import { Injectable } from '@angular/core';
import { IconSettingsService } from '@progress/kendo-angular-icons';

@Injectable({
  providedIn: 'root'
})
export class IconService extends IconSettingsService
{
  private iconDictionary: { [key: string]: string } = {
    plus: 'k-icon k-i-plus',
    minus: 'k-icon k-i-minus',
  };

  public getCustomFontIconClass(iconName: string): string
  {
    return (this.iconDictionary[iconName] || super.getCustomFontIconClass(iconName));
  }
}
